<div class="p-4 flex-col flex gap-2">
    <h3 class="flex items-center gap-2 mb-2">
        <i class="pi pi-history text-gray-500 text-xl font-bold"></i> 最新告警 (前5筆)
    </h3>

    @if (alarmsData().length === 0) {
    <div class="text-center text-gray-400 text-xs py-4 bg-white rounded-lg">
        <i class="pi pi-check-circle text-2xl mb-1 text-green-500"></i>
        <div>目前系統正常運作中</div>
    </div>
    }

    <div class="flex flex-col gap-3">
        @for (alarm of alarmsData(); track $index) {
        <div class=" p-3 rounded-lg shadow-sm border-l-4 hover:shadow-md transition-all cursor-pointer min-h-[80px] flex flex-col justify-center"
            [ngClass]="alarm.status === 0 ? 'bg-red-50 border-l-red-400' : 'bg-green-50 border-l-green-400'"
            (click)="alarmClick.emit(alarm)">
            <div class="flex justify-between items-center mb-1">
                <span class="px-2 py-0.5 text-sm text-white bg-primary rounded font-bold">
                    {{ alarm.systemName }}
                </span>
                <div class="text-xs text-gray-500 flex items-center gap-1">
                    <i class="pi pi-clock text-[11px]"></i> {{ alarm.triggerTime | date:'MM/dd HH:mm' }}
                </div>
            </div>
            <div class="font-bold text-base text-gray-800 mb-1 line-clamp-1">{{ alarm.deviceName }}</div>
            <div class="flex flex-col items-start gap-3 text-gray-500 text-[12px] mt-1">
                <div>{{ alarm.description }}</div>
                <div class="flex items-center gap-1">
                    <i class="pi pi-map-marker text-[10px]"></i> {{ alarm.floorName }} · {{ alarm.spaceName
                    }}
                </div>
            </div>
        </div>
        }
    </div>

    <p-button label="查看更多" icon="pi pi-arrow-right" iconPos="right" styleClass="w-full"
        (onClick)="router.navigate(['/alerts'], { queryParams: { statuses: [0] } })">
    </p-button>
</div>
